import React from "react";
import { Section } from "./ui/Section";
import { GdprDataPurposes } from "./GdprModal";

/**
 * Podmínky používání a zásady ochrany osobních údajů (/gdpr).
 * Titulek a tlačítko Zpět dodává AppShell (Screen v App.tsx). Seznam
 * shromažďovaných údajů a jejich účelu je sdílený s dialogem GdprModal
 * na přihlašovací stránce. Odstavec o vývoji aplikace je na stránce
 * O aplikaci.
 */

import { CONTACT_EMAIL } from "./utils/contact";

const GDPRPage: React.FC = () => (
  <>
    <Section title="Podmínky používání" icon="bi-file-earmark-text">
      <p>
        Tato aplikace slouží pro správu registrací a plateb účastníků
        sportovních závodů organizovaných LKS.
      </p>
      <p className="mb-0">
        Používáním aplikace potvrzujete, že jste se s těmito podmínkami
        seznámili a souhlasíte s nimi.
      </p>
    </Section>

    <Section title="Shromažďované údaje" icon="bi-person-lines-fill">
      <p>
        Při registraci shromažďujeme jméno, příjmení, e-mail, telefon, rok
        narození, pohlaví, státní občanství, číslo a platnost ZP, u některých
        závodů i číslo dokladu totožnosti, informace o členství a o
        registracích na závody. Používáme je k těmto účelům:
      </p>
      <GdprDataPurposes className="mb-0" />
    </Section>

    <Section title="Přístup a zabezpečení" icon="bi-shield-lock">
      <p>
        Jméno a příjmení, číslo uživatele, státní občanství a výsledky jsou
        součástí startovních listin, výsledkových listin a živé tabule, které
        jsou veřejné. Ostatní údaje (kontakt, rok narození, zbrojní průkaz,
        doklady, členství a platby) zpracovávají správci klubu a pořadatelé
        závodů. Údaje nepředáváme třetím stranám k jiným účelům.
      </p>
      <p className="mb-0">
        Data jsou uložena v databázi Firebase (Google Cloud) a přenášena
        šifrovaně.
      </p>
    </Section>

    <Section title="Vaše práva" icon="bi-person-check">
      <p>
        Máte právo na přístup, opravu, vymazání, omezení zpracování,
        přenositelnost údajů a odvolání souhlasu. Pro uplatnění kontaktujte{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
      <p className="mb-0">
        Svůj účet můžete také sami smazat v aplikaci: Profil → Upravit
        profil.
      </p>
    </Section>

    <Section title="Notifikace" icon="bi-bell">
      <p className="mb-0">
        Aplikace může zasílat notifikace, a to jen pro informování uživatelů
        o nových závodech, organizačních změnách, případně o příchozích
        platbách. Počet notifikací nepřesáhne 5 za jeden kalendářní měsíc.
      </p>
      <p className="mt-2 mb-0">
        Kdo se sám zapíše na čekací listinu závodu, dostane navíc e-mail
        pokaždé, když se na závodě uvolní místo – do limitu výše se nepočítá
        a z čekací listiny se lze kdykoli odebrat.
      </p>
    </Section>
  </>
);

export default GDPRPage;
